/* istanbul ignore file */
import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import { EntityHeader } from 'framework/ui/layout';

const AccountEntityHeader = ({ entityTitle = '' }) => {
  const props = entityTitle ? { entityTitle } : { entityTitleSource: 'accountName' };

  return <EntityHeader {...props} defaultAuthor={DEFAULT_ENTITY_AUTHOR} />;
};

export default AccountEntityHeader;
